import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getAccountDetails = () => {
    return axiosPrivate.get(`/bills/api/v1/converted-pay/account-details/`);
}